<template>
  <div id="credits" class="main-page-content">
    <div class="container main-page-content__container">
      <div class="row main-page-content__row">
        <div class="row-height main-page-content__row-height">
          <div class="col-sm-4 col-height e-bg-anred">
						<h1>Красная книга Архнадзора</h1>
						<h2>электронный каталог объектов недвижимого культурного наследия Москвы, находящихся под угрозой</h2>
						<div>
							<a href="/map" id="btn-read-bottom" class="btn btn-default btn-darkred">На карте Москвы</a>
							<br>&nbsp;<br>
							<a href="/read" id="btn-read-bottom" class="btn btn-default btn-darkred">Галерея</a>
						</div>

					</div>

          <p v-if="loading" class="main-page-content__status">
            Загрузка…
          </p>
          <p v-else-if="loadError" class="main-page-content__status main-page-content__status--error">
            {{ loadError }}
          </p>
          <div v-else class="main-page-content__body" v-html="html"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
async function fetchMainPage() {
  const res = await fetch('/api/v1/main', {
    cache: 'no-store',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const msg = body && body.error ? body.error : `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return res.json();
}

export default {
  name: 'MainPageContent',
  data() {
    return {
      html: '',
      loading: true,
      loadError: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.loadError = null;
      try {
        const data = await fetchMainPage();
        this.html = typeof data.html === 'string' ? data.html : '';
      } catch (e) {
        this.loadError = e instanceof Error ? e.message : 'Не удалось загрузить страницу';
        this.html = '';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.main-page-content__status {
  margin: 1rem 0;
}

.main-page-content__status--error {
  color: #b91c1c;
}

.main-page-content__body {
  margin: 15px;
}

.main-page-content {
  position: relative;
  margin: 0;
  padding: 0;
  left: auto;
  top: auto;
  width: 100%;
  max-width: none;
  height: auto;
  min-height: 0;
  overflow: visible;
}

.main-page-content__container {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
}

.main-page-content__row {
  width: 100%;
  margin: 0;
}

.main-page-content__row-height {
  width: 100%;
}

.main-page-content h1,
.main-page-content h2 {
  color: #111827;
}
</style>
